import React from 'react';
import { Route, Switch } from 'react-router';
import ViewESYs from './view';
import EditESYs from './edit';
import CreateESYs from './create';

const ESYs = () => {
  return (
    <Switch>
      <Route exact path='/admin/esys' component={ViewESYs} />
      <Route exact path='/admin/esys/new' component={CreateESYs} />
      <Route exact path='/admin/esys/:id' component={EditESYs} />
    </Switch>
  );
};

export default ESYs;
